// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"5112e088","6580":"a7cf472a","8096":"879587da"}[chunkId] + ".chunk.css";
};